export { DocumentsTabBarIcon } from './DocumentsTabBarIcon';
export { DocumentsPulseIcon } from './DocumentsPulseIcon';
